import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook som leser innstillingen 'picking.hideConsolidationPrompt'.
 *
 * Når PÅ skjules samlastings-spørsmålet («2 ordrer med samme leveringsadresse —
 * Samlasting / Per ordre» + fordelingsvalget «Kopier identisk / Del likt») i
 * DeliveryInfoModal ved direkte plukk-avslutning. Modalen går da rett til
 * per ordre-modus. Ordre som skal sendes samlet håndteres i stedet i pakkemodulen
 * («Til Pakking»), der kolli/vekt/paller registreres én gang per forsendelse.
 *
 * Innført for Norlux (2026-07): operatørene opplevde samlastings-valget som
 * forvirrende («del likt» ga bl.a. 0,5 pall per ordre i eksporten).
 *
 * Default: false (prompten vises som før med mindre tenant eksplisitt slår den av).
 */
export function useHideConsolidationPrompt(): boolean {
  const [hidden, setHidden] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('picking.hideConsolidationPrompt');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setHidden(val === 'true' || val === '1' || val === 'ja');
          } else {
            setHidden(false);
          }
        }
      } catch (err) {
        console.warn('Could not load picking.hideConsolidationPrompt setting, defaulting to false:', err);
        if (!cancelled) {
          setHidden(false);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return hidden;
}
